const pageOneCharacterCount = 1305
const pageTwoCharacterLimit = 2415

// Find the best word boundary to split a paragraph at
const findSplitIndex = (paragraph, availableChars) => {
  if (paragraph.length <= availableChars) return paragraph.length

  // Find the last space that fits within the limit
  const maxIndex = Math.min(availableChars, paragraph.length)
  for (let i = maxIndex; i >= 0; i--) {
    if (paragraph[i] === ' ') return i
  }
  return -1 // No suitable split point found
}

// Helper function to process paragraphs within a character limit
const processParagraphsWithinLimit = (paragraphsToProcess, charLimit, allowPartialFit = true, skipChars = 0) => {
  const result = []
  let characterCount = skipChars
  let splitParagraphRemainder = null
  let paragraphsProcessed = 0

  for (let i = 0; i < paragraphsToProcess.length; i++) {
    const paragraph = paragraphsToProcess[i]
    const availableChars = charLimit - characterCount

    // If the paragraph fits completely, add it
    if (paragraph.length <= availableChars) {
      result.push(paragraph)
      characterCount += paragraph.length
      paragraphsProcessed = i + 1
    } else if (allowPartialFit) {
      // Try to split the paragraph at a word boundary
      const splitIndex = findSplitIndex(paragraph, availableChars)

      if (splitIndex > 0) {
        result.push(paragraph.slice(0, splitIndex))
        characterCount += splitIndex
        splitParagraphRemainder = paragraph.slice(splitIndex + 1) // Skip the space
        paragraphsProcessed = i + 1
      }

      break // Stop processing after handling partial fit
    } else {
      // For page two, don't try to fit partial paragraphs - just stop here
      break
    }
  }

  return {
    paragraphs: result,
    characterCount,
    splitParagraphRemainder,
    paragraphsProcessed,
  }
}

export default function calculatePageParagraphs(paragraphs = []) {
  // Default behavior - calculate for both pages
  if (paragraphs.length === 0) {
    return { paragraphsPageOne: [], remainingParagraphs: [] }
  }

  // Process paragraphs for page one (allow partial fitting)
  const pageOneResult = processParagraphsWithinLimit(paragraphs, pageOneCharacterCount, true)

  // Determine remaining paragraphs for page two
  let remainingToProcess = paragraphs.slice(pageOneResult.paragraphsProcessed)
  if (pageOneResult.splitParagraphRemainder) {
    remainingToProcess = [pageOneResult.splitParagraphRemainder, ...remainingToProcess]
  }

  // Process page two (don't allow partial fitting)
  const pageTwoResult =
    remainingToProcess.length > 0
      ? processParagraphsWithinLimit(remainingToProcess, pageTwoCharacterLimit, false)
      : { paragraphs: [] }

  return {
    paragraphsPageOne: pageOneResult.paragraphs,
    remainingParagraphs: pageTwoResult.paragraphs,
  }
}
